"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = tslib_1.__importDefault(require("react"));
var tester_1 = require("./tester");
var getCategoryClassName = function (category, selectedCategory) {
    return selectedCategory === category ? 'selected' : '';
};
exports.CategorizationList = function (_a) {
    var categorization = _a.categorization, selectedCategory = _a.selectedCategory, depth = _a.depth, onSelect = _a.onSelect, subcategoriesClassName = _a.subcategoriesClassName, groupClassName = _a.groupClassName;
    return (react_1.default.createElement("ul", { className: subcategoriesClassName }, categorization.elements.map(function (category) {
        if (tester_1.isCategorization(category)) {
            return (react_1.default.createElement("li", { key: category.label, className: groupClassName },
                react_1.default.createElement("span", null, category.label),
                react_1.default.createElement(exports.CategorizationList, { categorization: category, selectedCategory: selectedCategory, depth: depth + 1, onSelect: onSelect, subcategoriesClassName: subcategoriesClassName, groupClassName: groupClassName })));
        }
        else {
            return (react_1.default.createElement("li", { key: category.label, onClick: onSelect(category), className: getCategoryClassName(category, selectedCategory) },
                react_1.default.createElement("span", null, category.label)));
        }
    })));
};
//# sourceMappingURL=CategorizationList.js.map